import { ButtonColor } from "@/common/enum/button-color";
import { LoginPath } from "@/common/enum/path";
import { maskEmail } from "@/common/util/mask-email";
import { FindIdAndPasswordTab } from "@/types/payload/find-id-and-password-tab";
import { Button } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { Body14Regular } from "../typography/Body14Regular";
import { Body14Underline } from "../typography/Body14Underline";
import { Body16Medium } from "../typography/Body16Medium";
import { H4 } from "../typography/H4";

interface Props {
  findPartnerEmail: string;
  clearFindPartnerEmail: () => void;
  updateActiveTab: (tab: FindIdAndPasswordTab) => void;
}

export const FindIdCompletePanel: React.FC<Props> = ({
  findPartnerEmail,
  clearFindPartnerEmail,
  updateActiveTab,
}) => {
  const navigate = useNavigate();

  const handleLoginClick = async () => {
    navigate(LoginPath.LOGIN);
  };

  const handleFindPasswordClick = () => {
    clearFindPartnerEmail();
    updateActiveTab(FindIdAndPasswordTab.PASSWORD);
  };

  return (
    <div className="flex flex-col items-center text-center w-[400px]">
      <H4 className="text-semantic-text-heading mb-[16px]">아이디 찾기</H4>
      {/* TODO 수정필요 */}
      <Body14Regular className="text-gray-800 mb-[32px]">
        입력하신 정보로 찾은 아이디입니다.
      </Body14Regular>

      <div className="w-full bg-gray-50 px-[133.5px] py-[32px] rounded-[8px] mb-[32px]">
        <Body16Medium className="mb-[12px] text-gray-800">
          가입한 아이디
        </Body16Medium>
        <Body14Regular className="text-primary-500">
          {maskEmail(findPartnerEmail, 7)}
        </Body14Regular>
      </div>
      <Button
        className="w-full mb-[24px]"
        color={ButtonColor.PRIMARY}
        onClick={handleLoginClick}
      >
        로그인 하기
      </Button>
      <div
        className="cursor-pointer text-semantic-text-body"
        onClick={handleFindPasswordClick}
      >
        <Body14Underline>비밀번호 찾기</Body14Underline>
      </div>
    </div>
  );
};
